module.exports = __webpack_public_path__ + "static/media/card_bg_1.b8fc51c4.png";